import { Table } from "antd";
import React from "react";
const columns = [
  {
    title: "Order",
    dataIndex: "name",
  },
  {
    title: "Total Orders",
    dataIndex: "total_orders",
  },
  {
    title: "Total Order Value",
    dataIndex: "total_order_value",
  },
  {
    title: "Average Order Value",
    dataIndex: "average_order_value",
  },
];

const onChange = (pagination, filters, sorter, extra) => {
};
const OrderTable = ({ orderCoachData, loading }) => {
  const dataArray = [];
  const mappedData = orderCoachData?.statsByTag;
  for (const key in orderCoachData) {
    if (orderCoachData.hasOwnProperty(key)) {
      dataArray.push({
        name: key,
        ...orderCoachData[key],
      });
    }
  }

  return (
    <Table
      columns={columns}
      dataSource={dataArray}
      onChange={onChange}
      loading={loading}
      pagination={false}
    />
  );
};
export default OrderTable;
